import { render, staticRenderFns } from "./AwaitingProcessingBlock.vue?vue&type=template&id=229b8479&scoped=true&"
import script from "./AwaitingProcessingBlock.vue?vue&type=script&lang=js&"
export * from "./AwaitingProcessingBlock.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingProcessingBlock.vue?vue&type=style&index=0&id=229b8479&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229b8479",
  null
  
)

export default component.exports